import React from "react";
import {
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import { EMOTIONS } from "../../../sketches/constants/presets";
import "./EmotionSelector.css";

// TODO: move theme colors to global styles
const EmotionSelector = ({ selectedEmotion, onEmotionChange }) => {
  return (
    <FormControl component="fieldset">
      <p className="groupTitle">Choose a base emotion</p>
      <RadioGroup
        row
        aria-label="emotion"
        name="emotion"
        value={selectedEmotion}
        onChange={(e) => onEmotionChange(e)}
      >
        {EMOTIONS.map((emotion) => (
          <FormControlLabel
            value={emotion}
            control={
              <Radio
                sx={{
                  color: "primary.main",
                  "&.Mui-checked": { color: "primary.main" },
                }}
              />
            }
            label={emotion}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

export default EmotionSelector;
